import React, { Component } from 'react';
import { Modal,Button,Input, Icon,Upload,message,Spin } from 'antd';
import './style/layout.less'
import API_URL from '../../common/url';
import $ from '../../common/AjaxRequest';
import MultiInput from './MultiInput';
import ExportUtil from '../../common/ExportUtil';
import { xToken } from '../../common/AjaxRequest';

class Filter extends Component {

    state = {
        searchParams: {
        },
        fileList: [],
        uploading: false,
    }

    componentDidMount() {

    }

    download = () => {
        const url = API_URL.home.getFtpRerecordJdeImport;
        ExportUtil.export(null, null, url);
    }

    beforeUpload = file => {
        this.setState({ uploading: true });
    }

    handleUploadChange = ({ file, fileList }) => {
        const { fileList: fList } = this.state;
        const { status, uid, response } = file;
        const{JDEdata=[]}=this.props;
        if (status === 'done' && (fList || []).find(i => i.uid == uid)) {
            this.setState({ uploading: false });
            const {  error,datas } = response || {};
            if (error) {
                message.error(error);
            }else{
                const concatArry = JDEdata.concat(datas);
                let arrNew = new Set(concatArry);
                const newArry=Array.from(arrNew).slice(0,20);
                this.props.handleChange(newArry);
                this.props.jugeTolast("mulInput")
            }
        }

        this.setState({ fileList });
    }

    render() {
        const{uploading,fileList}=this.state;
        return (
            <div className="filter-wrap" style={{ padding: 10, background: '#fff',display:"flex" }}>
             <div className="filter-item" style={{marginLeft:"15px",marginTop:"5px"}}>    
             <span style={{marginRight: 15}}>请选择手动重跑的合同：</span>
             </div>
            <div className="filter-item" style={{marginLeft:"15px"}}>
                <Button type="primary" onClick={this.download}>下载模板</Button>
            </div>
            <div className="filter-item" style={{marginLeft:"15px"}}>
            <Upload
                        key="import"
                            data={{
                            curUserId: sessionStorage.userId,
                            curEmployeeCode: sessionStorage.curEmployeeCode || '',
                            }}
                        showUploadList={false}
                        action={API_URL.home.importRerecordInvJdeContractCode}
                        beforeUpload={this.beforeUpload}
                        onChange={this.handleUploadChange}
                        fileList={fileList}
                        headers={xToken}
                     >
                 <Button type="primary" disabled={uploading}>导入JDE项目号</Button>
            </Upload>
            </div>
        </div>
        )
    }
}

class RerunContent extends Component {

    state = {
        searchParams: {
        },
    }

    componentDidMount() {

    }


    jugeTolast=(id)=>{
        this.multiInputRef.jugeTolast(id);
    }

    changeValue=()=>{
        this.multiInputRef.setValue(""); 
    }

    changeHaveNoJDE=(blur)=>{
        this.multiInputRef.changeHaveNoJDE(blur);
    }

    setRemindList=(notExistJdeCodes,duplicateJdeCodes)=>{
        this.multiInputRef.setRemindList(notExistJdeCodes,duplicateJdeCodes) 
    }

    render() {
        const{JDEdata=[]}=this.props;
        return (
        <div className="filter-wrap" style={{ padding: 10,
         //background: 'rgb(250, 249, 255)',
         //maxHeight:"220px",
         marginLeft:"25px",marginRight:"25px" }}>
            <MultiInput list={JDEdata} onChange={this.props.handleChange} 
             ref={el => this.multiInputRef = el}
            />
        </div>
        )
    }
}

class ManualRerunModal extends Component {

    state = {
        visible: false,
        JDEdata:[],
        saveLoading: false,
        submitLoading: false
    }

    show = () => {
        this.setState({ visible: true });
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    
    loadData = () => {
        this.setState({ loading: true });
        const{JDEdata=[]}=this.state;
        const options = {
            method: 'POST',
            url: API_URL.home.queryReadyRerecordInvJdeContract,
            data: {

            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [] } = res;
                if(datas.length>0){
                const {contractList=[],jdeRerecordId}=datas&&datas[0];
                let arry =[];
                if(contractList.length>0){
                    contractList.map((item, i) => {
                        arry.push(item.jdeCode);
                    });
                    this.setState({
                        JDEdata: arry,
                    });   
                }
                this.setState({
                    jdeRerecordId
                });
                }
                this.setState({
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    hide = () => {
        this.setState({ visible: false,JDEdata:[],saveLoading:false,submitLoading:false });
        this.rerunContentRef.changeValue("");
        this.rerunContentRef.changeHaveNoJDE(false);
    }

    save = () => {
        const{JDEdata=[],}=this.state;
        this.setState({
            saveLoading:true
        });
        if(JDEdata.length>0){
            const JDEs = JDEdata.toString();
            const options = {
                method: 'POST',
                url: API_URL.home.batchRerecordInvJdeContract,
                data: { operation: 'save',jdeCodes:JDEs, },
                dataType: 'json',
                doneResult: res => {
                    this.setState({
                        saveLoading:false
                        });
                    if(res.error){
                        message.error(res.error);
                    }else{    
                    const{datas={}}=res;

                    const successInfo =datas&&datas.message;
                    const{notExistJdeCodes=[],duplicateJdeCodes=[]}=datas;

                    this.rerunContentRef.setRemindList(notExistJdeCodes,duplicateJdeCodes);
                    if(duplicateJdeCodes.length>0){
                        const firstErr = duplicateJdeCodes&&duplicateJdeCodes[0];
                        const index = JDEdata.indexOf(firstErr);
                        this.rerunContentRef.jugeTolast(`${index}choose`);
                        return;
                    }else if
                    (notExistJdeCodes.length>0){
                      const firstErr = notExistJdeCodes&&notExistJdeCodes[0];
                      const index = JDEdata.indexOf(firstErr);
                      this.rerunContentRef.jugeTolast(`${index}choose`);
                      return
                    }
                    if(!((notExistJdeCodes.length>0)&&(duplicateJdeCodes.length>0))){
                        //message.success(successInfo);
                        message.success(res&&res.success);
                    }
                   }
                }
            }
            $.sendRequest(options);
        }else{
            this.rerunContentRef.changeHaveNoJDE(true);
            this.setState({
                saveLoading:false
            });
        }

       
        // if(JDEdata.length>0){
        //     this.rerunContentRef.jugeTolast("1choose")
        // }
        console.log(JDEdata);
    }

    submitConfirm = () => {
        const{JDEdata=[],}=this.state;
        this.setState({
            submitLoading:true
        });
        if(JDEdata.length>0){
        Modal.confirm({
            iconType: 'exclamation-circle',
            title: <span>确认对已添加的JDE项目号进行重跑？</span>,
            content: 'JDE项目号一旦参与重跑，会根据该JDE项目号的当前数据，重新生成财务收入报告、代垫费用收入报告、中心收入报告',
            onOk: this.remind,
            onCancel: ()=>{this.setState({submitLoading:false})}
        });
       }else{
        this.rerunContentRef.changeHaveNoJDE(true);
        this.setState({
            submitLoading:false
        });  
       }
    }

    remind = () => {
        const{JDEdata=[],}=this.state;
        const JDEs = JDEdata.toString();
        const options = {
            method: 'POST',
            url: API_URL.home.batchRerecordInvJdeContract,
            data: { operation: 'run',jdeCodes:JDEs, },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    submitLoading:false
                });
                if(res){  
                const{datas={}}=res;
                // const{failCount,successCount}=datas;

                  const{notExistJdeCodes=[],duplicateJdeCodes=[],jdeRerecordId}=datas;

                  this.rerunContentRef.setRemindList(notExistJdeCodes,duplicateJdeCodes);

                  if(duplicateJdeCodes.length>0){
                      const firstErr = duplicateJdeCodes&&duplicateJdeCodes[0];
                      const index = JDEdata.indexOf(firstErr);
                      this.rerunContentRef.jugeTolast(`${index}choose`);
                      return;
                  }else if
                  (notExistJdeCodes.length>0){
                    const firstErr = notExistJdeCodes&&notExistJdeCodes[0];
                    const index = JDEdata.indexOf(firstErr);
                    this.rerunContentRef.jugeTolast(`${index}choose`);
                    return
                  }
                  if(!((notExistJdeCodes.length>0)&&(duplicateJdeCodes.length>0))){
                    message.success(res.success);
                    this.hide();
                     this.reRun(jdeRerecordId);
                  }
                }      
            }, errorResult: (res) => {
                // message.error(res.error);
                this.setState({
                    submitLoading:false
                });
                this.hide();
            }
        }
        $.sendRequest(options);

        //console.log(JDEdata);
    }

    reRun=(jdeRerecordId)=>{
         const options = {
            method: 'POST',
            url: API_URL.home.startRerecordTask,
            data: {jdeRerecordId},
            dataType: 'json',
            doneResult: res => {
                const{datas,success}=res;
                const { successCount,failCount } = datas;
                  if(success){
                    Modal.success({
                        title: '已添加的JDE项目号重跑完成！',
                        content: <span>重跑成功{`${successCount}`}条<br/>失败记录{`${failCount}`}条</span>,
                        okText:"知道了"
                     });
                   }
            }
        }
        $.sendRequest(options); 
    }



    handleChange = (value) => {
        this.setState({
            JDEdata: value
        })
        console.log(this.state.JDEdata)
    }

    jugeTolast=(id)=>{
        this.setState({
            jugeId:id
        });
        this.rerunContentRef.jugeTolast(id);
    }

    render() {
        const { visible,JDEdata,saveLoading,submitLoading } = this.state;
        return (
            <Modal
                title='手动重跑'    
                visible={visible}
                onCancel={this.hide}
                bodyStyle={{ maxHeight:"400px" }}
                maskClosable={false}
                footer={[
                    <Button key="back" size="large" onClick={this.hide}>关闭</Button>,
                    <Button type="primary" onClick={this.save} loading={saveLoading}>保存</Button>,
                    <Button type="primary" onClick={this.submitConfirm} loading={submitLoading}>保存并开始重跑</Button>
                ]}
            >
                 <Spin spinning={saveLoading||submitLoading}>
                <Filter  handleChange={value => this.handleChange(value)} JDEdata={JDEdata} jugeTolast={this.jugeTolast}/>
                <div className="filter-item" style={{marginLeft:"25px",marginTop:"5px"}}>    
               <span style={{marginRight: 15,color:"red"}}>为了不影响系统性能，每次重跑不可超过20个JDE项目号</span>
               </div>
                <RerunContent handleChange={value => this.handleChange(value)} JDEdata={JDEdata}
                  ref={el => this.rerunContentRef = el}
                />
                </Spin>
            </Modal>
        );
    }
}

export default ManualRerunModal;



// WEBPACK FOOTER //
// ./src/components/layout/ManualRerunModal.js